import { FC } from "react";
import AIOTable from './../../components/aio/aio-table';
import { useFreelancerProvider, useRootFreelancerProvider } from "./context";
import { I_model } from "./types";
import { hasPermission } from "utils/HasPermission";
import { Icon } from "@mdi/react";
import { mdiHuman, mdiOfficeBuilding } from "@mdi/js";

export const Table: FC = () => {
    const { gridHook, openEditModal, rolesHook } = useFreelancerProvider()
    const { popup, apis } = useRootFreelancerProvider();
    const paging = { size: gridHook.gridFilter.pageSize, number: gridHook.gridFilter.pageNumber, length: gridHook.gridFilter.rowsLength, serverSide: true }
    const openChangePasswordModal = async (username: string) => {
        popup.addConfirm({
            title: 'تعییر رمز عبور',
            text: 'آیا از تغییر رمز عبور اطمینان دارید؟',
            onSubmit: async () => {
                const res = await apis.changePassword(username)
                if(res){
                    popup.addSnackebar({
                        type:'success',
                        text:'تغییر رمز عبور با موفقیت انجام شد'
                    })
                    return true
                }
                else {return false}
            },
            submitText: 'تایید',
            canselText: 'لغو'
        })
    }
    const openRemoveModal = async (id: number) => {
        popup.addConfirm({
            title: 'حذف راننده',
            text: 'آیا از حذف راننده اطمینان دارید؟',
            onSubmit: async () => {
                const res = await apis.remove(id)
                if (res) {
                    gridHook.updateGrid()
                }
                return res
            },
            submitText: 'تایید',
            canselText: 'لغو'
        })
    }

    return (
        <AIOTable<I_model>
            value={gridHook.grid || []}
            headerAttrs={{ style: { background: '#FFEAE9' } }}
            cellAttrs={({ row, rowIndex }) => {
                return {
                    style: { height: 48, background: rowIndex % 2 !== 0 ? '#f8f8f8' : '#fff' }
                }
            }}
            placeholder='موردی وجود ندارد'
            templates={{
                date: ({ row }) => {
                    const { year, month, day } = row.createDate;
                    return <>{`${year}/${month}/${day}`}</>
                },
                actions: ({ row }) => {
                    const editPerm = hasPermission('edit_freelanser_personel')
                    const removePerm = hasPermission('delete_freelanser_personel')
                    const asign_personel_organization = hasPermission('asign_personel_organization')
                    const asign_personel_role = hasPermission('asign_personel_role')
                    return (
                        <div className="flex flex-row items-center gap-1" style={{ display: 'flex' }}>
                            {!!asign_personel_organization && <div className="msf" title='نقش' onClick={() => rolesHook.openRoleModal(row)}><Icon path={mdiHuman} size={0.8} /></div>}
                            {!!asign_personel_role && <div className="msf" title='هاب' onClick={() => rolesHook.openHubModal(row)}><Icon path={mdiOfficeBuilding} size={0.8} /></div>}


                            {!!editPerm && <div className="msf" title='ویرایش' onClick={() => openEditModal(row.id)}><SVG2 /></div>}
                            {!!removePerm && <div className="msf" title='حذف' onClick={() => openRemoveModal(row.id)}><SVG1 /></div>}
                            <div className="msf" title='تغییر رمز عبور' onClick={() => openChangePasswordModal(row.username)}><ChangePasswordIcon /></div>
                        </div>
                    )
                },
                hasInsurance: ({ row }) => {
                    if (row.hasInsurance) { return 'بیمه دارد' }
                    return null
                }
            }}
            paging={paging}
            onChangePaging={async (paging) => await gridHook.changeGridFilter({ ...gridHook.gridFilter, pageSize: paging.size, pageNumber: paging.number }, true)}
            columnOption={{
                justify: ({ column }) => true
            }}
            columns={[
                { id: 'type', title: 'نوع همکاری', value: 'row.type.text', minWidth: 144 },
                { id: 'name', title: 'نام و نام خانوادگی', value: 'row.name', minWidth: 144 },
                { id: 'nationalCode', title: 'کد ملی', value: 'row.nationalCode', minWidth: 144 },
                { id: 'mobile', title: 'موبایل', value: 'row.mobile', minWidth: 144 },
                { id: 'email', title: 'پست الکترونیک', value: 'row.email', minWidth: 240 },
                { id: 'date', title: 'تاریخ ایجاد', value: 'row.createDate', template: 'date', minWidth: 144 },
                { id: 'username', title: 'نام کاربری', value: 'row.username', minWidth: 144 },
                { id: 'isActive', title: 'وضعیت', value: `row.isActive ? 'فعال' : 'غیر فعال'`, minWidth: 144 },
                { id: 'recommenderCode', title: 'کد معرف', value: `row.recommenderCode`, minWidth: 144 },
                { id: 'marketerCode', title: 'کد بازاریاب', value: `row.marketerCode`, minWidth: 144 },
                { id: 'hasInsurance', title: 'بیمه', value: `row.hasInsurance`, minWidth: 144, template: 'hasInsurance' },
                { id: 'actions', title: 'عملیات', template: 'actions', minWidth: 160 },

            ]}
        />
    )
}

const SVG1: FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.5 20.5V5.99998H4.5V4.49998H9V3.61548H15V4.49998H19.5V5.99998H18.5V20.5H5.5ZM7 19H17V5.99998H7V19ZM9.404 17H10.9037V7.99998H9.404V17ZM13.0962 17H14.596V7.99998H13.0962V17Z" fill="#666666" />
        </svg>
    )
}
const SVG2: FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_2467_875)">
                <path d="M2 24V21H22V24H2ZM6 16.4135H7.2365L15.5365 8.12875L14.9078 7.4905L14.2848 6.877L6 15.177V16.4135ZM4.5 17.9135V14.5385L16.7885 2.2655L20.1327 5.65575L7.875 17.9135H4.5ZM15.5365 8.12875L14.9078 7.4905L14.2848 6.877L15.5365 8.12875Z" fill="#666666" />
            </g>
            <defs>
                <clipPath id="clip0_2467_875">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    )
}
const SVG3: FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11.25 16.75H12.75V11H11.25V16.75ZM12 9.2885C12.2288 9.2885 12.4207 9.21108 12.5755 9.05625C12.7303 8.90142 12.8077 8.70958 12.8077 8.48075C12.8077 8.25192 12.7303 8.06008 12.5755 7.90525C12.4207 7.75058 12.2288 7.67325 12 7.67325C11.7712 7.67325 11.5793 7.75058 11.4245 7.90525C11.2697 8.06008 11.1923 8.25192 11.1923 8.48075C11.1923 8.70958 11.2697 8.90142 11.4245 9.05625C11.5793 9.21108 11.7712 9.2885 12 9.2885ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z" fill="#666666" />
        </svg>
    )
}

const ChangePasswordIcon: FC = () => {
    return (
        <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 8C6 5.79 7.79 4 10 4S14 5.79 14 8 12.21 12 10 12 6 10.21 6 8M12 18.2C12 17.24 12.5 16.34 13.2 15.74V15.5C13.2 15.11 13.27 14.74 13.38 14.38C12.35 14.14 11.21 14 10 14C5.58 14 2 15.79 2 18V20H12V18.2M22 18.3V21.8C22 22.4 21.4 23 20.7 23H15.2C14.6 23 14 22.4 14 21.7V18.2C14 17.6 14.6 17 15.2 17V15.5C15.2 14.1 16.6 13 18 13C19.4 13 20.8 14.1 20.8 15.5V17C21.4 17 22 17.6 22 18.3M19.5 15.5C19.5 14.7 18.8 14.2 18 14.2C17.2 14.2 16.5 14.7 16.5 15.5V17H19.5V15.5Z" />
        </svg>
    )
}